import React from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const comparisonTable = [{
  sit: 'El bebé se despierta cada hora',
  sin: 'No sabés si es hambre, gas o simplemente biología del bebé',
  con: 'La Guía de Señales de Sueño te dice exactamente qué está pasando y qué hacer'
}, {
  sit: 'Lo acostás dormido y se despierta apenas lo ponés en la cuna',
  sin: 'Lo volvés a levantar y el ciclo agotador no termina nunca',
  con: 'El Sistema de Asociaciones de Sueño te enseña a cambiarlo gradualmente sin llanto'
}, {
  sit: 'Semana 4 con 2 horas seguidas de sueño como máximo',
  sin: 'Pensás que algo está mal o que estás haciendo algo incorrectamente',
  con: 'El Calendario de Crisis te muestra que es completamente normal y exactamente cuándo pasa'
}, {
  sit: 'El bebé llora y absolutamente nada lo calma',
  sin: 'Probás todo al azar desesperadamente y nada funciona',
  con: 'Las 5S del Dr. Karp te dan un protocolo de calma con pasos en orden exacto'
}, {
  sit: 'Llega la regresión de los 4 meses y todo empeora',
  sin: 'Lo vivís como una catástrofe creyendo que se quedó sin leche',
  con: 'Sabés que es un avance neurológico real y tenés el plan exacto para atravesarlo'
}, {
  sit: 'Las tomas nocturnas te están destruyendo físicamente',
  sin: 'Cada despertar nocturno es un esfuerzo máximo que agota más',
  con: 'La Técnica del Dream Feed y la toma en sueño reducen el impacto al mínimo posible'
}];
const offRoadFeatures = ['La ciencia del sueño neonatal explicada sin tecnicismos ni términos médicos', 'Las ventanas de sueño por edad para nunca más sobrecansa al bebé sin saberlo', 'El Ritual de las 3S para crear la asociación de sueño correcta desde el principio', 'Técnica del swaddle paso a paso con verificación de seguridad incluida', 'El Dream Feed para alargar el primer bloque de sueño nocturno', 'La Técnica de La Pausa para enseñarle a conectar ciclos de sueño solo', 'Las 5S del Dr. Karp para calmar al bebé inconsolable en cualquier momento', 'Masaje infantil para cólicos y gases con técnica paso a paso ilustrada', 'Calendario completo de crisis de crecimiento semana a semana', 'Guía de seguridad SMSL: las reglas que toda mamá argentina debe conocer', 'Tracker nocturno de tomas y despertares imprimible para las primeras semanas', 'Hoja de ruta maestra de los 100 días con hitos de sueño y alimentación'];
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24" data-id="element-63">
      <div className="max-w-6xl mx-auto px-4" data-id="element-64">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16" data-id="element-65">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 text-red-600 font-bold text-sm mb-8 border border-red-200 shadow-sm" data-id="element-66">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-67" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <CountdownTimer data-id="element-68" />

          <p className="text-lg md:text-xl text-gray-700 mt-8 mb-6" data-id="element-69">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-white shadow-md border border-pink-200 rounded-xl p-4" data-id="element-70">
            <div className="text-sm font-bold text-red-600 flex items-center gap-2 mb-2" data-id="element-71">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-72" />
              Cupos al precio de lanzamiento — Quedan pocos
            </div>
            <div className="w-full bg-gray-100 rounded-full h-3 overflow-hidden mb-1" data-id="element-73">
              <div className="bg-gradient-to-r from-red-500 to-red-400 h-3 rounded-full" style={{
              width: '72%'
            }} data-id="element-74" />
            </div>
            <div className="text-xs text-gray-500 text-right" data-id="element-75">
              72% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-10 md:mb-16" data-id="element-76">
          ELEGÍ TU MEGA PACK
        </h2>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-20 md:mb-24" data-id="element-77">
          {/* Card 1 */}
          <div className="bg-white shadow-xl border border-pink-200 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-78">
            <div className="text-4xl mb-4" data-id="element-79">📘</div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-80">
              MEGA PACK MAMÁ PRIMERIZA™
            </h3>
            <p className="text-fuchsia-600 font-medium mb-5 text-sm md:text-base" data-id="element-81">
              6 Tomos + 6 Bonos de Aplicación Inmediata
            </p>
            <div className="bg-pink-50 rounded-xl p-4 mb-6 border border-pink-100" data-id="element-82">
              <span className="text-gray-500 text-xs block mb-1" data-id="element-83">
                Ideal para:
              </span>
              <span className="text-gray-800 font-medium text-sm" data-id="element-84">
                Mamás primerizas que quieren atravesar el embarazo y los
                primeros días con su bebé con información clara, sistema
                organizado y sin ansiedad innecesaria que les robe el disfrute.
              </span>
            </div>
            <div className="mb-6" data-id="element-85">
              <div className="text-gray-400 line-through text-lg" data-id="element-86">$146.000</div>
              <div className="text-4xl md:text-5xl font-bold text-gray-900" data-id="element-87">
                $19.990
              </div>
            </div>
            <a href="https://www.nexorecursos.com/cart/52509436772628:1" className="w-full py-4 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-900 font-bold text-base md:text-lg transition-colors mt-auto border border-gray-200 text-center block" data-id="element-88">
              → QUIERO MI MEGA PACK AHORA
            </a>
          </div>

          {/* Card 2 - Highlighted */}
          <div className="bg-gradient-to-b from-white to-pink-50 border-2 border-fuchsia-400 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col relative shadow-2xl" style={{
          boxShadow: '0 20px 40px -15px rgba(217,70,239,0.2)'
        }} data-id="element-89">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-fuchsia-500 text-white font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wide shadow-md" data-id="element-90">
              MÁS ELEGIDO
            </div>
            <div className="text-4xl mb-4" data-id="element-91">🏆</div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-92">
              MEGA PACK + MÉTODO SUEÑO Y CALMA ⭐
            </h3>
            <p className="text-fuchsia-600 font-medium mb-5 text-sm md:text-base" data-id="element-93">
              6 Tomos + 6 Bonos + Sistema Completo de Sueño para los Primeros
              100 Días
            </p>
            <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-xl p-4 mb-6" data-id="element-94">
              <span className="text-fuchsia-600/80 text-xs block mb-1" data-id="element-95">
                Ideal para:
              </span>
              <span className="text-gray-800 font-medium text-sm" data-id="element-96">
                Mamás que quieren además un sistema probado para que su bebé
                aprenda a conectar ciclos de sueño desde la semana 1, recuperar
                su propio descanso y atravesar los primeros 100 días sin
                colapsar por el agotamiento crónico.
              </span>
            </div>
            <div className="mb-6" data-id="element-97">
              <div className="text-gray-400 line-through text-lg" data-id="element-98">$195.000</div>
              <div className="text-4xl md:text-5xl font-bold text-gray-900" data-id="element-99">
                $27.990
              </div>
            </div>
            <a href="https://www.nexorecursos.com/cart/52509446570260:1" className="animate-pulse-glow w-full py-4 rounded-xl bg-fuchsia-500 hover:bg-fuchsia-600 text-white font-bold text-base md:text-lg transition-all active:scale-95 mt-auto text-center block shadow-lg shadow-fuchsia-500/30" data-id="element-100">
              → QUIERO EL MEGA PACK + MÉTODO SUEÑO Y CALMA
            </a>
          </div>
        </div>

        {/* Off-Road CEO Comparison */}
        <div className="max-w-5xl mx-auto" data-id="element-101">
          <h3 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-10 md:mb-12" data-id="element-102">
            🕊️ ¿QUÉ AGREGA EL MÉTODO SUEÑO Y CALMA?
          </h3>

          <div className="bg-white shadow-xl border border-pink-200 rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-12" data-id="element-103">
            <div className="overflow-x-auto" data-id="element-104">
              <table className="w-full text-left min-w-[700px]" data-id="element-105">
                <thead data-id="element-106">
                  <tr className="bg-pink-50" data-id="element-107">
                    <th className="p-4 md:p-6 text-gray-700 font-semibold text-sm border-b border-pink-200 w-1/3" data-id="element-108">
                      Tu situación
                    </th>
                    <th className="p-4 md:p-6 text-red-500 font-semibold text-sm border-b border-pink-200 w-1/3" data-id="element-109">
                      ❌ Sin Método Sueño y Calma
                    </th>
                    <th className="p-4 md:p-6 text-fuchsia-600 font-semibold text-sm border-b border-pink-200 w-1/3" data-id="element-110">
                      ✅ Con Método Sueño y Calma
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-111">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-pink-100 hover:bg-pink-50/50 transition-colors" data-id="element-112">
                      <td className="p-4 md:p-6 text-gray-900 font-medium text-sm" data-id="element-113">
                        {row.sit}
                      </td>
                      <td className="p-4 md:p-6 text-gray-600 text-sm" data-id="element-114">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-fuchsia-600 font-medium text-sm" data-id="element-115">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white/80 backdrop-blur-sm shadow-lg border border-pink-200 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-116">
            <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8 text-center" data-id="element-117">
              ✅ EL MÉTODO SUEÑO Y CALMA INCLUYE:
            </h4>
            <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-118">
              {offRoadFeatures.map((f, i) => <div key={i} className="flex items-start gap-3" data-id="element-119">
                  <span className="text-fuchsia-500 mt-0.5 shrink-0" data-id="element-120">✅</span>
                  <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-121">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}